import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAllContact } from "./services/contact.services";
import { IContact, IContactState } from "./contactModel";

const initialState: IContactState = {
  loading: false,
  formLoading: false,
  error: "",
  ContactList: [],
  ContactID: null,
  FilterContact: {
    Name: "",
    Email: "",
    MobileNo: "",
  },
};

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    setContactID: (state, action) => {
      state.ContactID = action.payload;
    },
    clearContactID: (state) => {
      state.ContactID = initialState.ContactID;
    },

    setFilterContact: (state, action) => {
      state.FilterContact = action.payload;
    },
    clearFilterContact: (state) => {
      state.FilterContact = initialState.FilterContact;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllContact.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllContact.fulfilled,
      (state, action: PayloadAction<IContact[]>) => {
        state.loading = false;
        state.ContactList = action.payload || [];
      }
    );
    builder.addCase(getAllContact.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ContactList = [];
    });
  },
});

export const {
  clearContactID,
  setContactID,
  clearFilterContact,
  setFilterContact,
} = contactSlice.actions;
export default contactSlice.reducer;
